<p-overlayPanel
  [id]="'list-in-dropdown-' + listInDropdown.id"
  styleClass="common-dropdown-list__overlay-container">
  <ng-template pTemplate="content">
    <div class="common-dropdown-list__info-items-title">
      <div class="common-dropdown-list__info-items-title-block">
        <span-tooltip
          class="common-dropdown-list__info-items-title-label"
          [text]="listInDropdown.title"
          [tooltipPosition]="'top'">
        </span-tooltip>
        @if (subtitle) {
          <span-tooltip
            class="common-dropdown-list__info-items-subtitle-label"
            [text]="subtitle"
            [tooltipPosition]="'top'">
          </span-tooltip>
        }
      </div>
      <button
        class="common-button__icon-xs-noborder"
        (click)="closeDropdown($event)">
        <i class="lf-icon-close-thick common-icon__sm"></i>
      </button>
    </div>
    <div class="common-dropdown-list__info-elements">
      @for (participant of list; track $index) {
        <div class="common-dropdown-list__info-items-simple"
          [ngClass]="{'common-dropdown-list__info-items-simple--highlighted': type === 'confidential' && participant.responsible}">
          @if(type === 'groups'){
              <i class="lf-icon-user-special common-icon__md-code-color-neutral-grey-800"
              [ngClass]="participant.type ==='user'?'lf-icon-user-special':'lf-icon-user'"></i>
          }
          <span-tooltip
            class="common-dropdown-list__info-items-simple-label"
            [text]="participant.fullName"
            [isDeleted]="participant.isDeleted"
            [tooltipPosition]="'top'">
          </span-tooltip>
        </div>
      }
    </div>
  </ng-template>
</p-overlayPanel>
